import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk,userServiceAuth} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/


export function userSaveCore(user) {
  return {
    type: constants.USER_CORE_SET,
    user
  };
}


export function userSaveProfile(user) {
  return {
    type: constants.USER_PROFILE_SET,
    user
  };
}


export function userSaveWishlists(wishlists) {
  return {
    type: constants.USER_WISHLISTS_SET,
    wishlists
  };
}

export function userSaveOrders(orders) {
  return {
    type: constants.USER_ORDERS_SET,
    orders
  };
}

export function userSaveExternalOrders(orders) {
  return {
    type: constants.USER_EXTERNAL_ORDERS_SET,
    orders
  };
}


/******************************
*******  Asynchronous  ********
******************************/



export function userSetProfile(profileData) {
  return dispatch => {

    let url = api.USER_API + endpoint.USER_SERVICE_PROFILE;
    return fetch(url, {
      method: 'put',
      headers: userServiceAuth(api.HEADERS),
      body: JSON.stringify(profileData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userGetProfile() {
  return dispatch => {

    let url = api.USER_API + endpoint.USER_SERVICE_PROFILE;

    return fetch(url, {
      method: 'get',
      headers: userServiceAuth(api.HEADERS),
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userGetUser() {
  return dispatch => {

    let url = api.MAGENTO_API + endpoint.MAGENTO_GET_USER;

    return fetch(url, {
      method: 'get',
      headers: userServiceAuth(api.HEADERS),
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userGetWishlists() {
  return dispatch => {

    let url = api.USER_API + endpoint.WISHLISTS_V2;
    return fetch(url, {
      method: 'get',
      headers: userServiceAuth(api.HEADERS),
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userCreateWishlist(name) {
  return dispatch => {

    let url = api.USER_API + endpoint.WISHLISTS_V2;
    let wishlistData = {
      name: name,
    }

    return fetch(url, {
      method: 'post',
      headers: userServiceAuth(api.HEADERS),
      body: JSON.stringify(wishlistData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userEditWishlist(wishlist_id, name) {
  return dispatch => {

    let url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id;
    let wishlistData = {
      wishlist_id: wishlist_id,
      name: name,
    }

    return fetch(url, {
      method: 'put',
      headers: userServiceAuth(api.HEADERS),
      body: JSON.stringify(wishlistData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userDeleteWishlist(wishlist_id) {
  return dispatch => {

    let url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id;
    let wishlistData = {
      wishlist_id: wishlist_id,
    }

    return fetch(url, {
      method: 'delete',
      headers: userServiceAuth(api.HEADERS),
      body: JSON.stringify(wishlistData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userWishlistAddItem(wishlist_id, sku) {
  return dispatch => {

    let url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id + '/add';
    let wishlistData = {
      wishlist_id: wishlist_id,
      sku: sku,
    }

    return fetch(url, {
      method: 'post',
      headers: userServiceAuth(api.HEADERS),
      body: JSON.stringify(wishlistData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userWishlistRemoveItem(wishlist_id, item_id) {
  return dispatch => {

    let url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id + '/remove';
    let wishlistData = {
      wishlist_id: wishlist_id,
      item_id: item_id,
    }

    return fetch(url, {
      method: 'post',
      headers: userServiceAuth(api.HEADERS),
      body: JSON.stringify(wishlistData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userShareWishlist(wishlist_id, name, email) {
  return dispatch => {

    let url = api.USER_API + endpoint.WISHLISTS_V2 + wishlist_id + '/share';
    let wishlistData = {
      recipient_name: name,
      recipient_email: email,
    }

    return fetch(url, {
      method: 'post',
      headers: userServiceAuth(api.HEADERS),
      body: JSON.stringify(wishlistData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userGetOrders(uid) {
  return dispatch => {

    let url = api.MAGENTO_API + endpoint.MAGENTO_GET_ORDERS + '?customer_id=' + String(uid);
    // let wishlistData = {
    //   wishlist_id: wishlist_id,
    //   item_id: item_id,
    // }

    return fetch(url, {
      method: 'get',
      headers: userServiceAuth(api.HEADERS),
      // body: JSON.stringify(wishlistData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function userGetExternalOrders() {
  return dispatch => {

    let url = api.ORDERS_API + endpoint.ORDERS_GET_EXTERNAL;

    return fetch(url, {
      method: 'get',
      headers: userServiceAuth(api.HEADERS),
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function userForgotPassword(email) {
  return dispatch => {

    let url = api.MAGENTO_API + endpoint.MAGENTO_FORGOT_PASSWORD;

    let fpData = {
      email: email,
      template: 'email_reset',
      websiteId: 1,
    }

    return fetch(url, {
      method: 'put',
      headers: api.HEADERS,
      body: JSON.stringify(fpData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}





// WEBPACK FOOTER //
// ./src/actions/user.jsx